/* eslint-disable */
export const deliveryStatusMapping = {
  delivered: [
    //ecotrack
    "livre_non_encaisse",
    "encaissé_non_payé",
    "paiements_prets",
    "paye_et_archive"
  ],
  returned: [
    //ecotrack
    "retour_chez_livreur",
    "retour_transit_entrepot",
    "retour_en_traitement",
    "retour_recu",
    "retour_archive",
    "annule"
  ],
  on_shipping: [
    //ecotrack
    "prete_a_expedier",
    "en_ramassage",
    "en_preparation_stock",
    "vers_hub",
    "en_hub",
    "vers_wilaya",
    "en_preparation",
    "en_livraison",
    "suspendu"
  ],
};
